import React from 'react';
import _ from 'lodash';
import {
  Create,
  SelectInput,
  ReferenceInput,
  FileInput,
  ImageField,
} from 'react-admin';
import { SimpleForm } from 'ra-ui-materialui/lib/form';
import { offeringCategory } from '../../helpers/mappings';
import { isRequired } from '../../validators';


export const docChoices = [
  {
    id: 'offeringDocuments',
    name: 'Offering Document',
  },
  {
    id: 'riskFactors',
    name: 'Risk Factors',
  },
  {
    id: 'offeringSummary',
    name: 'Offering Summary',
  },
  {
    id: 'investorPresentation',
    name: 'Investor Presentation',
  },
  {
    id: 'subscriptionAgreement',
    name: 'Subscription Agreement',
  },
  {
    id: 'offeringCircularDocument',
    name: 'Circular Offering Document',
  },
];

const optionRenderer = choice => `${choice.name} | ${_.values(offeringCategory).find(item => item.value === choice.category).label} | (${choice.status} - ${choice.id})`;

export default props => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <ReferenceInput
        label="Offers"
        source="offerId"
        reference="offerings"
        perPage={100}
      >
        <SelectInput
          optionText={optionRenderer}
        />
      </ReferenceInput>
      <SelectInput
        source="docType"
        validate={isRequired}
        choices={docChoices}
      />
      <FileInput source="_document" label="Document" accept="application/pdf">
        <ImageField source="src" title="title" />
      </FileInput>
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/OfferDocument/Create.js